import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.png";

const ProjectPage = () => {
  return (
    <Fragment>
      <Navbar hclass={"wpo-site-header wpo-site-header-s2"} Logo={Logo} />
      <PageTitle pageTitle={"Portafolio"} pagesub={"Portafolio"} />
      <ProjectSection
        hclass={"project_section_s3 section-padding"}
        ShowSectionTitle={false}
        sliceStart={0}
        sliceEnd={6}
      />
      <Footer hclass={"wpo-site-footer"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPage;
